import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../../utils/api';
import toast from 'react-hot-toast';
import BackButton from '../../../components/common/BackButton';

const G     = '#166534';
const LIGHT = '#DCFCE7';

const STEPS = ['Property', 'Details', 'Media', 'Verification'];

const AMENITIES = ['Water Source', 'Electricity', 'Irrigation', 'Fencing', 'Farm House', 'Other'];
const MATERIALS = ['Borewell', 'Drip Irrigation', 'Farm Equipment', 'Shed / Warehouse', 'Other'];
const LAND_TYPES = ['Farmland', 'Orchard', 'Plantation', 'Greenhouse', 'Other'];
const SOIL_TYPES = ['Alluvial', 'Black', 'Red', 'Laterite', 'Sandy', 'Clay'];
const AREA_UNITS = ['Acre', 'Hectare', 'Bigha', 'Cent'];
const DOC_TYPES  = ['Aadhaar Card', 'PAN Card', 'Voter ID', 'Passport'];

function Field({ label, children }) {
  return (
    <div style={{ marginBottom:16 }}>
      <div style={{ fontSize:13, fontWeight:600, color:'#1a1a1a', marginBottom:6 }}>{label}</div>
      {children}
    </div>
  );
}

const inputStyle = {
  width:'100%', padding:'11px 13px', border:'1.5px solid #E5E7EB', borderRadius:10,
  fontSize:13, outline:'none', boxSizing:'border-box', color:'#374151', background:'white',
};

export default function LandAddPropertyPage() {
  const navigate = useNavigate();
  const photoRef    = useRef();
  const videoRef    = useRef();
  const ownerDocRef = useRef();
  const selfieRef   = useRef();
  const extraDocRef = useRef();

  const [step, setStep]       = useState(1);
  const [saving, setSaving]   = useState(false);
  const [uploading, setUploading] = useState(false);

  const [category, setCategory] = useState('Rental');
  const [photos, setPhotos]     = useState([]);
  const [video, setVideo]       = useState(null);
  const [amenities, setAmenities] = useState({});
  const [materials, setMaterials] = useState({});
  const [ownerDocUrl, setOwnerDocUrl]     = useState(null);
  const [selfieUrl, setSelfieUrl]         = useState(null);
  const [extraDocUrl, setExtraDocUrl]     = useState(null);

  const [form, setForm] = useState({
    price: '', address: '', totalArea: '', areaUnit: 'Acre', landType: '', frontage: '',
    soilType: '', landUse: '', description: '', materialsOther: '',
    ownerDocType: '',
  });
  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const next = () => {
    if (step === 1 && !form.address.trim()) return toast.error('Address is required');
    if (step === 1 && !form.price)           return toast.error('Price is required');
    setStep(s => Math.min(4, s + 1));
  };
  const back = () => (step === 1 ? navigate(-1) : setStep(s => s - 1));

  const uploadFiles = async (files, kind) => {
    if (!files.length) return [];
    setUploading(true);
    try {
      const fd = new FormData();
      Array.from(files).forEach(f => fd.append('files', f));
      const { data } = await api.post('/upload/media', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return (data.files || []).map(f => f.url);
    } catch {
      toast.error('Upload failed');
      return [];
    } finally { setUploading(false); }
  };

  const handlePhotoUpload = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, 10 - photos.length);
    if (!files.length) return;
    const urls = await uploadFiles(files);
    setPhotos(p => [...p, ...urls].slice(0, 10));
  };

  const handleVideoUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const urls = await uploadFiles([file]);
    if (urls[0]) setVideo(urls[0]);
  };

  const handleOwnerDocUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const urls = await uploadFiles([file]);
    if (urls[0]) setOwnerDocUrl(urls[0]);
  };

  const handleSelfieUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const urls = await uploadFiles([file]);
    if (urls[0]) setSelfieUrl(urls[0]);
  };

  const handleExtraDocUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const urls = await uploadFiles([file]);
    if (urls[0]) setExtraDocUrl(urls[0]);
  };

  const submit = async () => {
  if (!ownerDocUrl) return toast.error('Please upload your owner document');
  if (!selfieUrl) return toast.error('Please upload your selfie');

  const payload = {
    listingType: category === 'Sale' ? 'sale' : 'lease',
    price: parseFloat(form.price) || 0,
    address: form.address.trim(),
    area: parseFloat(form.totalArea) || 0,
    areaUnit: form.areaUnit,
    landType: form.landType,
    frontage: form.frontage,
    soilType: form.soilType,
    landUse: form.landUse,
    description: form.description.trim(),
    amenities: Object.keys(amenities).filter(k => amenities[k]),
    materials: Object.keys(materials).filter(k => materials[k]),
    materialsOther: form.materialsOther.trim(),
    photos,
    video,
    ownerDocType: form.ownerDocType,
    ownerDocUrl,
    selfieUrl,
    extraDocUrl,
  };

  console.log("========== LAND SUBMIT ==========");
  console.log("Request Payload:", payload);

  setSaving(true);

  try {
    const response = await api.post("/land/", payload);

    console.log("Success Response:", response);
    console.log("Status:", response.status);
    console.log("Data:", response.data);

    toast.success("Property submitted for verification!");
    navigate("/land/my-listings");

  } catch (err) {
    console.error("========== API ERROR ==========");
    console.error("Full Error:", err);

    if (err.response) {
      console.error("Status:", err.response.status);
      console.error("Response Data:", err.response.data);
      console.error("Headers:", err.response.headers);
    } else if (err.request) {
      console.error("No response received:", err.request);
    } else {
      console.error("Error Message:", err.message);
    }

    toast.error(
      err.response?.data?.message ||
      err.message ||
      "Failed to submit property"
    );
  } finally {
    setSaving(false);
  }
};
  return (
    <div style={{ background:'#F5F7FA', minHeight:'100vh', fontFamily:'Inter,system-ui,sans-serif', display:'flex', flexDirection:'column' }}>

      {/* Header */}
      <div style={{ background:G, padding:'14px 16px', display:'flex', alignItems:'center', gap:12 }}>
        <BackButton onClick={back} />
        <div style={{ fontSize:17, fontWeight:700, color:'white' }}>Add Property</div>
      </div>

      {/* Stepper */}
      <div style={{ display:'flex', alignItems:'flex-start', padding:'16px 16px 10px', background:'white', borderBottom:'1px solid #F1F3EE' }}>
        {STEPS.map((label, i) => {
          const num = i + 1;
          const done = num < step;
          const current = num === step;
          return (
            <React.Fragment key={label}>
              <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:4, width:56 }}>
                <div style={{
                  width:26, height:26, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center',
                  fontSize:11.5, fontWeight:700,
                  background: done || current ? G : '#F1F3EE',
                  color: done || current ? 'white' : '#9CA3AF',
                }}>
                  {done ? '✓' : num}
                </div>
                <span style={{ fontSize:9.5, fontWeight: current ? 700 : 500, color: current ? G : '#9CA3AF', textAlign:'center' }}>{label}</span>
              </div>
              {num !== STEPS.length && (
                <div style={{ flex:1, height:2, marginTop:12, background: done ? G : '#F1F3EE' }} />
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div style={{ padding:'16px 14px', flex:1 }}>

        {/* Step 1 — Property */}
        {step === 1 && (
          <>
            <Field label="Property Category">
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8 }}>
                {['Rental', 'Sale', 'Lease'].map(c => {
                  const active = category === c;
                  return (
                    <button key={c} onClick={() => setCategory(c)}
                      style={{
                        padding:'14px 6px', borderRadius:12, fontSize:12, fontWeight:700, cursor:'pointer',
                        border:`1.5px solid ${active ? G : '#E5E7EB'}`,
                        background: active ? LIGHT : 'white',
                        color: active ? G : '#6B7280',
                      }}>
                      {c}
                    </button>
                  );
                })}
              </div>
            </Field>

            <Field label={`Price ${category === 'Sale' ? '(total)' : '(per month)'}`}>
              <input type="number" value={form.price} onChange={e => set('price', e.target.value)}
                placeholder="Enter price in ₹" style={inputStyle} />
            </Field>

            <Field label="Address">
              <input value={form.address} onChange={e => set('address', e.target.value)}
                placeholder="Enter complete address" style={inputStyle} />
            </Field>

            <div style={{ fontSize:14, fontWeight:700, color:'#1a1a1a', marginBottom:10 }}>Land Details</div>

            <Field label="Total Area">
              <div style={{ display:'flex', gap:8 }}>
                <input type="number" value={form.totalArea} onChange={e => set('totalArea', e.target.value)}
                  placeholder="Enter total area" style={{ ...inputStyle, flex:1 }} />
                <select value={form.areaUnit} onChange={e => set('areaUnit', e.target.value)}
                  style={{ ...inputStyle, width:100 }}>
                  {AREA_UNITS.map(u => <option key={u} value={u}>{u}</option>)}
                </select>
              </div>
            </Field>

            <Field label="Land Type">
              <select value={form.landType} onChange={e => set('landType', e.target.value)} style={inputStyle}>
                <option value="">Select land type</option>
                {LAND_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </Field>

            <Field label="Frontage (Road)">
              <input value={form.frontage} onChange={e => set('frontage', e.target.value)}
                placeholder="Enter frontage (in ft)" style={inputStyle} />
            </Field>

            <Field label="Soil Type">
              <select value={form.soilType} onChange={e => set('soilType', e.target.value)} style={inputStyle}>
                <option value="">Select soil type</option>
                {SOIL_TYPES.map(t => <option key={t} value={t}>{t}</option>)}
              </select>
            </Field>
          </>
        )}

        {/* Step 2 — Details */}
        {step === 2 && (
          <>
            <div style={{ fontSize:14, fontWeight:700, color:'#1a1a1a', marginBottom:14 }}>Land & Property Details</div>

            <Field label="Land Use">
              <select value={form.landUse} onChange={e => set('landUse', e.target.value)} style={inputStyle}>
                <option value="">Select land use</option>
                {['Agriculture', 'Horticulture', 'Livestock', 'Mixed Use'].map(u => <option key={u} value={u}>{u}</option>)}
              </select>
            </Field>

            <Field label="Facilities / Amenities">
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                {AMENITIES.map(a => (
                  <label key={a} style={{ display:'flex', alignItems:'center', gap:8, fontSize:12.5, color:'#374151' }}>
                    <input type="checkbox" checked={!!amenities[a]}
                      onChange={() => setAmenities(p => ({ ...p, [a]: !p[a] }))}
                      style={{ width:16, height:16, accentColor:G }} />
                    {a}
                  </label>
                ))}
              </div>
            </Field>

            <Field label="Description">
              <textarea value={form.description} onChange={e => set('description', e.target.value.slice(0, 500))}
                placeholder="Describe about the land..." rows={4}
                style={{ ...inputStyle, resize:'none', fontFamily:'inherit' }} />
              <div style={{ textAlign:'right', fontSize:10, color:'#9CA3AF', marginTop:4 }}>{form.description.length}/500</div>
            </Field>

            <Field label="Materials Available">
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
                {MATERIALS.map(m => (
                  <label key={m} style={{ display:'flex', alignItems:'center', gap:8, fontSize:12.5, color:'#374151' }}>
                    <input type="checkbox" checked={!!materials[m]}
                      onChange={() => setMaterials(p => ({ ...p, [m]: !p[m] }))}
                      style={{ width:16, height:16, accentColor:G }} />
                    {m}
                  </label>
                ))}
              </div>
              <input value={form.materialsOther} onChange={e => set('materialsOther', e.target.value)}
                placeholder="Specify materials" style={inputStyle} />
            </Field>
          </>
        )}

        {/* Step 3 — Media */}
        {step === 3 && (
          <>
            <Field label="Upload Photos">
              <input ref={photoRef} type="file" accept="image/*" multiple style={{ display:'none' }} onChange={handlePhotoUpload} />
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8 }}>
                <button onClick={() => photoRef.current?.click()} disabled={uploading}
                  style={{ aspectRatio:'1', border:'2px dashed #E5E7EB', borderRadius:12, background:'white', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:4, cursor:'pointer', color:'#6B7280' }}>
                  <span style={{ fontSize:18 }}>📷</span>
                  <span style={{ fontSize:10, fontWeight:600, textAlign:'center' }}>{uploading ? 'Uploading...' : 'Upload Photos'}</span>
                  <span style={{ fontSize:9, color:'#9CA3AF' }}>Max 10 photos</span>
                </button>
                {photos.map((src, i) => (
                  <div key={i} style={{ position:'relative', aspectRatio:'1', borderRadius:12, overflow:'hidden' }}>
                    <img src={src} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                    <button onClick={() => setPhotos(p => p.filter((_, idx) => idx !== i))}
                      style={{ position:'absolute', top:4, right:4, width:18, height:18, borderRadius:'50%', background:'rgba(0,0,0,.6)', color:'white', border:'none', fontSize:11, cursor:'pointer' }}>×</button>
                  </div>
                ))}
              </div>
            </Field>

            <Field label="Upload Video">
              <input ref={videoRef} type="file" accept="video/*" style={{ display:'none' }} onChange={handleVideoUpload} />
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8 }}>
                {!video ? (
                  <button onClick={() => videoRef.current?.click()} disabled={uploading}
                    style={{ aspectRatio:'1', border:'2px dashed #E5E7EB', borderRadius:12, background:'white', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:4, cursor:'pointer', color:'#6B7280' }}>
                    <span style={{ fontSize:18 }}>🎥</span>
                    <span style={{ fontSize:10, fontWeight:600, textAlign:'center' }}>Upload Video</span>
                    <span style={{ fontSize:9, color:'#9CA3AF' }}>Max 30 sec</span>
                  </button>
                ) : (
                  <div style={{ position:'relative', aspectRatio:'1', borderRadius:12, overflow:'hidden', background:'black' }}>
                    <video src={video} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                    <span style={{ position:'absolute', inset:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, color:'white' }}>▶</span>
                    <button onClick={() => setVideo(null)}
                      style={{ position:'absolute', top:4, right:4, width:18, height:18, borderRadius:'50%', background:'rgba(0,0,0,.6)', color:'white', border:'none', fontSize:11, cursor:'pointer' }}>×</button>
                  </div>
                )}
              </div>
            </Field>

            <div style={{ fontSize:11, color:'#9CA3AF' }}>* Clear photos and videos help build trust</div>
          </>
        )}

        {/* Step 4 — Verification */}
        {step === 4 && (
          <>
            <div style={{ fontSize:14, fontWeight:700, color:'#1a1a1a', marginBottom:14 }}>Owner Verification</div>

            <Field label="Upload Owner Document">
              <select value={form.ownerDocType} onChange={e => set('ownerDocType', e.target.value)} style={{ ...inputStyle, marginBottom:8 }}>
                <option value="">Select document type</option>
                {DOC_TYPES.map(d => <option key={d} value={d}>{d}</option>)}
              </select>
              <input ref={ownerDocRef} type="file" accept="image/*,.pdf" style={{ display:'none' }} onChange={handleOwnerDocUpload} />
              <button onClick={() => ownerDocRef.current?.click()} disabled={uploading}
                style={{ width:'100%', padding:'20px', border:'2px dashed #E5E7EB', borderRadius:12, background:'white', display:'flex', flexDirection:'column', alignItems:'center', gap:4, cursor:'pointer', color: ownerDocUrl ? G : '#6B7280' }}>
                <span style={{ fontSize:18 }}>{ownerDocUrl ? '✅' : '📤'}</span>
                <span style={{ fontSize:12, fontWeight:600 }}>{ownerDocUrl ? 'Document Uploaded' : uploading ? 'Uploading...' : 'Upload Document'}</span>
                <span style={{ fontSize:10, color:'#9CA3AF' }}>JPG, PNG, PDF (Max 5MB)</span>
              </button>
            </Field>

            <Field label="Owner Selfie">
              <input ref={selfieRef} type="file" accept="image/*" capture="user" style={{ display:'none' }} onChange={handleSelfieUpload} />
              <button onClick={() => selfieRef.current?.click()} disabled={uploading}
                style={{ width:'100%', padding:'20px', border:'2px dashed #E5E7EB', borderRadius:12, background:'white', display:'flex', flexDirection:'column', alignItems:'center', gap:4, cursor:'pointer', color: selfieUrl ? G : '#6B7280' }}>
                <span style={{ fontSize:18 }}>{selfieUrl ? '✅' : '🤳'}</span>
                <span style={{ fontSize:12, fontWeight:600 }}>{selfieUrl ? 'Selfie Uploaded' : uploading ? 'Uploading...' : 'Upload Selfie'}</span>
                <span style={{ fontSize:10, color:'#9CA3AF' }}>Take a clear selfie</span>
              </button>
            </Field>

            <div style={{ fontSize:13, fontWeight:700, color:'#1a1a1a', marginBottom:4 }}>Property Verification (Optional)</div>
            <Field label="Upload Additional Document">
              <input ref={extraDocRef} type="file" accept="image/*,.pdf" style={{ display:'none' }} onChange={handleExtraDocUpload} />
              <button onClick={() => extraDocRef.current?.click()} disabled={uploading}
                style={{ width:'100%', padding:'20px', border:'2px dashed #E5E7EB', borderRadius:12, background:'white', display:'flex', flexDirection:'column', alignItems:'center', gap:4, cursor:'pointer', color: extraDocUrl ? G : '#6B7280' }}>
                <span style={{ fontSize:18 }}>{extraDocUrl ? '✅' : '📤'}</span>
                <span style={{ fontSize:12, fontWeight:600 }}>{extraDocUrl ? 'Document Uploaded' : uploading ? 'Uploading...' : 'Upload Document'}</span>
                <span style={{ fontSize:10, color:'#9CA3AF' }}>JPG, PNG, PDF (Max 5MB)</span>
              </button>
            </Field>
          </>
        )}
      </div>

      {/* Footer buttons — normal flow, no BottomNav on this route (see NO_NAV in App.js) */}
      <div style={{ display:'flex', gap:10, padding:'16px 14px calc(16px + env(safe-area-inset-bottom, 0px))', background:'white', borderTop:'1px solid #F1F3EE' }}>
        <button onClick={back}
          style={{ flex:1, padding:'13px', borderRadius:12, border:'1.5px solid #E5E7EB', background:'white', color:'#374151', fontSize:13.5, fontWeight:700, cursor:'pointer' }}>
          Back
        </button>
        {step < 4 ? (
          <button onClick={next}
            style={{ flex:1, padding:'13px', borderRadius:12, border:'none', background:G, color:'white', fontSize:13.5, fontWeight:700, cursor:'pointer' }}>
            Next
          </button>
        ) : (
          <button onClick={submit} disabled={saving}
            style={{ flex:1, padding:'13px', borderRadius:12, border:'none', background: saving ? '#9CA3AF' : G, color:'white', fontSize:13.5, fontWeight:700, cursor: saving ? 'not-allowed' : 'pointer' }}>
            {saving ? 'Submitting...' : 'Submit'}
          </button>
        )}
      </div>
    </div>
  );
}